module.exports = __webpack_public_path__ + "static/media/avocado_sponge.55b45140.png";